globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { Popover } from '@headlessui/react';
import { getAssetSrc, useNavigationContext } from '@restworld/utils-common';
import Image from 'next/image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FooterMainGrid = /*#__PURE__*/_styled.div.withConfig({
  displayName: "footercomponents__FooterMainGrid",
  componentId: "sc-y7ssg9-0"
})({
  "display": "grid",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "gap": "3rem",
  "@media (min-width: 768px)": {
    "gridTemplateColumns": "repeat(3, minmax(0, 1fr))",
    "gap": "1.5rem"
  }
});
export var FooterColumnGroup = /*#__PURE__*/_styled.div.withConfig({
  displayName: "footercomponents__FooterColumnGroup",
  componentId: "sc-y7ssg9-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});
export var FooterColumnTitle = /*#__PURE__*/_styled.p.withConfig({
  displayName: "footercomponents__FooterColumnTitle",
  componentId: "sc-y7ssg9-2"
})({
  "fontWeight": "600"
});
export var FooterColumnItemGroup = /*#__PURE__*/_styled.div.withConfig({
  displayName: "footercomponents__FooterColumnItemGroup",
  componentId: "sc-y7ssg9-3"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});
export var FooterColumnItem = function FooterColumnItem(_ref) {
  var href = _ref.href,
      children = _ref.children,
      comingSoon = _ref.comingSoon,
      newWindow = _ref.newWindow;

  var _useNavigationContext = useNavigationContext(),
      Link = _useNavigationContext.linkComponent;

  if (comingSoon) return /*#__PURE__*/_jsxs(_StyledPopover, {
    children: [/*#__PURE__*/_jsx(_StyledPopoverButton, {
      children: children
    }), /*#__PURE__*/_jsx(_StyledPopoverPanel, {
      children: /*#__PURE__*/_jsx("p", {
        children: "Coming soon ;)"
      })
    })]
  });
  if (newWindow) return /*#__PURE__*/_jsx("a", {
    href: href,
    className: "font-normal",
    target: "_blank",
    rel: "noreferrer",
    children: children
  });
  return /*#__PURE__*/_jsx(Link, {
    href: href,
    className: "font-normal",
    locale: '',
    children: children
  });
};

var SocialIcon = /*#__PURE__*/_styled.div.withConfig({
  displayName: "footercomponents__SocialIcon",
  componentId: "sc-y7ssg9-4"
})({
  "width": "1.5rem"
});

export var LogoAndSocials = function LogoAndSocials() {
  var _useNavigationContext2 = useNavigationContext(),
      Link = _useNavigationContext2.linkComponent;

  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/",
        children: /*#__PURE__*/_jsx(_StyledDiv2, {
          children: /*#__PURE__*/_jsx(Image, {
            width: 124,
            height: 36,
            src: getAssetSrc('/utils-assets/restworld-logo.svg'),
            alt: "restworld",
            priority: true
          })
        })
      })
    }), /*#__PURE__*/_jsx(SocialIcons, {})]
  });
};

var SmartAndStartLogo = /*#__PURE__*/_styled.div.withConfig({
  displayName: "footercomponents__SmartAndStartLogo",
  componentId: "sc-y7ssg9-5"
})({
  "display": "flex",
  "width": "66.666667%",
  "justifyContent": "center",
  "@media (min-width: 768px)": {
    "width": "100%"
  }
});

export var SmartAndStartLogos = function SmartAndStartLogos() {
  return /*#__PURE__*/_jsx(_StyledDiv3, {
    children: /*#__PURE__*/_jsxs(_StyledDiv4, {
      children: [/*#__PURE__*/_jsx(SmartAndStartLogo, {
        children: /*#__PURE__*/_jsx("img", {
          src: getAssetSrc('/utils-assets/smart-and-start/ue.svg'),
          alt: "Smart and Start UE logo"
        })
      }), /*#__PURE__*/_jsx(SmartAndStartLogo, {
        children: /*#__PURE__*/_jsx("img", {
          src: getAssetSrc('/utils-assets/smart-and-start/start.svg'),
          alt: "Smart and Start logo"
        })
      }), /*#__PURE__*/_jsx(SmartAndStartLogo, {
        children: /*#__PURE__*/_jsx("img", {
          src: getAssetSrc('/utils-assets/smart-and-start/imprese.svg'),
          alt: "Ministero delle imprese logo"
        })
      })]
    })
  });
};
export var SocialIcons = function SocialIcons() {
  return /*#__PURE__*/_jsxs(_StyledDiv5, {
    children: [/*#__PURE__*/_jsx(SocialIcon, {
      children: /*#__PURE__*/_jsx("a", {
        href: "https://www.facebook.com/restworld.it",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/_jsx(_StyledImg, {
          src: getAssetSrc('/utils-assets/social-icons/facebook.svg'),
          alt: "Facebook"
        })
      })
    }), /*#__PURE__*/_jsx(SocialIcon, {
      children: /*#__PURE__*/_jsx("a", {
        href: "https://www.instagram.com/restworld_hr/",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/_jsx(_StyledImg2, {
          src: getAssetSrc('/utils-assets/social-icons/instagram.svg'),
          alt: "Instagram"
        })
      })
    }), /*#__PURE__*/_jsx(SocialIcon, {
      children: /*#__PURE__*/_jsx("a", {
        href: "https://www.linkedin.com/company/restworld",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/_jsx(_StyledImg3, {
          src: getAssetSrc('/utils-assets/social-icons/linkedin.svg'),
          alt: "Linkedin"
        })
      })
    }), /*#__PURE__*/_jsx(SocialIcon, {
      children: /*#__PURE__*/_jsx("a", {
        href: "https://t.me/restworld_offerte",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/_jsx(_StyledImg4, {
          src: getAssetSrc('/utils-assets/social-icons/telegram.svg'),
          alt: "Telegram"
        })
      })
    })]
  });
};
export var Divider = /*#__PURE__*/_styled.hr.withConfig({
  displayName: "footercomponents__Divider",
  componentId: "sc-y7ssg9-6"
})({});
export var CopyrightContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "footercomponents__CopyrightContainer",
  componentId: "sc-y7ssg9-7"
})({
  "marginTop": "2.5rem",
  "marginBottom": "2.5rem",
  "textAlign": "justify",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(107 114 128 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "textAlign": "center"
  }
});

var _StyledPopover = /*#__PURE__*/_styled(Popover).withConfig({
  displayName: "footercomponents___StyledPopover",
  componentId: "sc-y7ssg9-8"
})({
  "position": "relative"
});

var _StyledPopoverButton = /*#__PURE__*/_styled(Popover.Button).withConfig({
  displayName: "footercomponents___StyledPopoverButton",
  componentId: "sc-y7ssg9-9"
})({
  "textAlign": "left",
  "fontWeight": "400"
});

var _StyledPopoverPanel = /*#__PURE__*/_styled(Popover.Panel).withConfig({
  displayName: "footercomponents___StyledPopoverPanel",
  componentId: "sc-y7ssg9-10"
})({
  "position": "absolute",
  "zIndex": "10",
  "borderRadius": "0.75rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(28 19 39 / var(--tw-bg-opacity))",
  "padding": "0.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footercomponents___StyledDiv",
  componentId: "sc-y7ssg9-11"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footercomponents___StyledDiv2",
  componentId: "sc-y7ssg9-12"
})({
  "marginRight": "0.75rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footercomponents___StyledDiv3",
  componentId: "sc-y7ssg9-13"
})({
  "display": "flex",
  "justifyContent": "center"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footercomponents___StyledDiv4",
  componentId: "sc-y7ssg9-14"
})({
  "marginTop": "2.5rem",
  "marginBottom": "2.5rem",
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "2.5rem",
  "@media (min-width: 768px)": {
    "width": "50%",
    "flexDirection": "row"
  }
});

var _StyledDiv5 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footercomponents___StyledDiv5",
  componentId: "sc-y7ssg9-15"
})({
  "display": "flex",
  "flexDirection": "row",
  "gap": "1.25rem"
});

var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "footercomponents___StyledImg",
  componentId: "sc-y7ssg9-16"
})({
  "marginRight": "0.75rem",
  "height": "2rem"
});

var _StyledImg2 = /*#__PURE__*/_styled("img").withConfig({
  displayName: "footercomponents___StyledImg2",
  componentId: "sc-y7ssg9-17"
})({
  "marginRight": "0.75rem",
  "height": "2rem"
});

var _StyledImg3 = /*#__PURE__*/_styled("img").withConfig({
  displayName: "footercomponents___StyledImg3",
  componentId: "sc-y7ssg9-18"
})({
  "marginRight": "0.75rem",
  "height": "2rem"
});

var _StyledImg4 = /*#__PURE__*/_styled("img").withConfig({
  displayName: "footercomponents___StyledImg4",
  componentId: "sc-y7ssg9-19"
})({
  "marginRight": "0.75rem",
  "height": "2rem"
});